// Corporate Charcoal — finance, private equity, law (dark/serious)
// Near-black charcoal + deep emerald, very angular corners
module.exports = {
  effect: 'none',
  colors: {
    main:            { light: '#fafaf9', dark: '#0c0c0b' },
    card:            { light: '#f2f2f0', dark: '#1a1a18' },
    surface:         { light: '#e4e4e0', dark: '#242422' },
    action:          { light: '#064e3b', dark: '#34d399' },
    actionHover:     { light: '#022c22', dark: '#6ee7b7' },
    textPrimary:     { light: '#111110', dark: '#f5f5f4' },
    textSecondary:   { light: '#292524', dark: '#d6d3d1' },
    textMuted:       { light: '#57534e', dark: '#a8a29e' },
    textMutedSubtle: { light: '#78716c', dark: '#78716c' },
    border:          { light: '#a8a29e', dark: '#2c2c2a' },
    borderSubtle:    { light: '#d6d3d1', dark: '#1f1f1d' },
    link:            { light: '#064e3b', dark: '#34d399' },
    linkBg:          { light: '#ecfdf5', dark: 'rgba(6,78,59,0.2)' },
    linkBorder:      { light: '#a7f3d0', dark: '#064e3b' },
    linkHover:       { light: '#d1fae5', dark: 'rgba(6,78,59,0.35)' },
    inputBg:         { light: '#ffffff', dark: '#1a1a18' },
    inputBorder:     { light: '#a8a29e', dark: '#2c2c2a' },
    inputText:       { light: '#111110', dark: '#f5f5f4' },
    focusRing:       { light: '#064e3b', dark: '#34d399' },
    overlay:         { light: 'rgba(0,0,0,0.6)', dark: 'rgba(0,0,0,0.85)' },
    confirm:         { light: '#78716c', dark: '#404040' },
    confirmHover:    { light: '#57534e', dark: '#525252' },
    confirmText:     { light: '#ffffff', dark: '#f5f5f4' },
    confirmBg:       { light: '#fafaf9', dark: '#1a1a18' },
    confirmBorder:   { light: '#e4e4e0', dark: '#2c2c2a' },
    success:         { light: '#064e3b', dark: '#34d399' },
    successHover:    { light: '#022c22', dark: '#10b981' },
    successBg:       { light: '#ecfdf5', dark: 'rgba(6,78,59,0.3)' },
    successText:     { light: '#059669', dark: '#6ee7b7' },
    successBorder:   { light: '#a7f3d0', dark: '#065f46' },
    error:           { light: '#9b1c1c', dark: '#f87171' },
    errorHover:      { light: '#7f1d1d', dark: '#ef4444' },
    errorBg:         { light: '#fef2f2', dark: 'rgba(127,29,29,0.3)' },
    errorText:       { light: '#dc2626', dark: '#fca5a5' },
    errorBorder:     { light: '#fecaca', dark: '#7f1d1d' },
    info:            { light: '#1e3a5f', dark: '#60a5fa' },
    infoHover:       { light: '#1e3a5f', dark: '#3b82f6' },
    infoBg:          { light: '#eff6ff', dark: 'rgba(30,58,95,0.3)' },
    infoText:        { light: '#3b82f6', dark: '#93c5fd' },
    infoBorder:      { light: '#bfdbfe', dark: '#1e3a5f' },
  },
  borderRadius: {
    card:      '10px',
    container: '6px',
    page:      '10px',
    button:    '4px',
    input:     '4px',
    badge:     '2px',
    full:      '9999px',
  },
  borderWidth: {
    default: '1px',
    thick:   '2px',
    avatar:  '3px',
    device:  '6px',
  },
  textures: {
    main:    { light: '', dark: '', size: '0', blendLight: 'normal', blendDark: 'normal', opacityLight: 0, opacityDark: 0 },
    surface: { light: '', dark: '' },
    card:    { light: '', dark: '' },
  },
};
